import { createFileRoute } from "@tanstack/react-router";
import { CredentialResetTemplate } from "~/features/auth/CredentialResetTemplate";

export const Route = createFileRoute("/credential-reset")({
  component: CredentialResetTemplate,
});
